import React from 'react';

import { PreviewFile } from '../PreviewFile';
import { ScrubberFrames } from '../components/Scrubber';

const PreviewWithScrubber = ({
  src,
  thumbnail,
  width = 160,
  height = 90,
  heightCover,
  aspectRatio,
  attributes,
  withOverlay,
  scrubbingUrls,
}) => {
  const [active, setActive] = React.useState(() => false);
  const handleMouseEnter = () => {
    setActive(true);
  };

  const handleMouseLeave = () => {
    setActive(false);
  };

  const scrubber = scrubbingUrls ? (
    <ScrubberFrames
      width={width}
      height={height}
      aspectRatio={aspectRatio}
      frames={scrubbingUrls}
      placeholderUrl={src}
    />
  ) : null;

  const preview = (
    <PreviewFile
      src={src}
      thumbnail={thumbnail}
      width={width}
      height={height}
      aspectRatio={aspectRatio}
      heightCover={heightCover}
      attributes={attributes}
      withOverlay={withOverlay}
    />
  );

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {/*{scrubber}*/}
      {active && scrubber ? scrubber : preview}
      {/*{preview}*/}
    </div>
  );
};

export default PreviewWithScrubber;
